import { useSortable } from "@dnd-kit/sortable";
import { CSS } from '@dnd-kit/utilities';
import { Box, Chip, Stack } from "@mui/material";
import { useFormContext } from "react-hook-form";
import ListDragHandle from "../../../../components/list-drag-handle/ListDragHandle";
import { ObjectTagValuesConfigurationFieldType, TagGroupTagFieldKeyType } from "../ObjectTagValuesConfigurationFieldTypes";

export type DisplayOptionsCardProps = {
    tagKey: TagGroupTagFieldKeyType;
};

export default function DisplayOptionsCard({
    tagKey
}: DisplayOptionsCardProps) {

    const {
        getValues
    } = useFormContext<ObjectTagValuesConfigurationFieldType>();

    const tag = getValues(tagKey);

    const {
        attributes,
        listeners,
        transform,
        transition,
        isDragging,
        setNodeRef,
        setActivatorNodeRef
    } = useSortable({ id: tag.equatableKey });

    return (
        <Stack
            ref={setNodeRef}
            style={{
                transform: CSS.Transform.toString(transform),
                transition
            }}
            direction="row"
            spacing={2}
            sx={{
                alignItems: "center",
                padding: 1,
                opacity: isDragging ? theme => theme.palette.action.disabledOpacity : 1,
                borderStyle: "none",
                borderWidth: 1,
                borderColor: "divider",
                borderBottomStyle: "solid"
            }}>
            <ListDragHandle
                ref={setActivatorNodeRef}
                {...listeners}
                {...attributes}
            />
            <Box sx={{ flexGrow: 1 }}>
                {tag.tatTypeName ?? tag.tatName}
                {tag.isNew &&
                    <Chip label="NEW!" color="secondary" sx={{ marginLeft: 1 }} size="small" />
                }
            </Box>
        </Stack>
    );
}
